<template>
	<div class="index">
		<swiper></swiper>
		<div class="container">
			<div class="newcenter">
				
			</div>
		</div>	
		 
		
		 
	 	<div class="newcenter movelist">		 	
			<h2>解决方案</h2>
			<p>SOLUTION</p>
			<div class="solution">
				<div class="main">
					<div class="move">
						<ul>
							<li v-for="item in solutionList" @click="gotoSolution(item.id)">{{item.name}}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
			
			<div class="container">
				<div class="newcenter">
					<h2>战略合作</h2>
					<p>STRATEGIC COOPERATION</p>
					<div class="cooperation">
						
	 					 <!-- 轮播图 -->
						<div class="swiper-container">
						    <div class="swiper-wrapper">
								<div class="swiper-slide" v-for="item in cooList">
									<img :src="item.imgUrl" style="width:100%">
									<p style="text-align:center">{{item.title}}</p>
								</div>
						    </div>
						    
						</div>
					</div>
				</div>
			
			</div>
	</div>
</template>

<script>
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	import swiper from './Icom/swiper';
	import news from './Icom/news';
	export default {
		name:'',
		components:{swiper,news},
		data(){
			return{
				msg:'index',
				navlist: [],
				itemId:'',
				cooList:[],
				solutionList:[]
			}
		},
		methods:{
			selItem(item) {
				$('.active').removeClass('active');
				$('#news_'+item).addClass('active');
				this.itemId = item;
				this.$refs.id.getList(item);
			},
			gotoNews(){
				this.$router.push({
				          	path: '/NewCenter',
				          	query: {
				          		id:	 this.itemId,         
				          	}
				      	})
			},
			getNewsNav(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsNavApi,
					data: {}
				})
				.then((res) => {
					this.navlist = res.data.data;
					if(this.navlist[0]){
						this.selItem(this.navlist[0].item_id);
						this.name = this.navlist[0].item_id;
						this.itemId = this.navlist[0].item_id;
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'1',
					data: {}
				})
				.then((res) => {
					$('.solution').css('background','url('+res.data.data.banner1+') 30%');
					$('.solution').css('background-size','180% 100%');
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.projectGetCooperationApi,
					data: {}
				})
				.then((res) => {
					this.cooList = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getItemList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.solutionGetListApi,
					data: {}
				})
				.then((res) => {
					this.solutionList = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			gotoSolution(id){
				this.$router.push({name:'Solution',params:{id:id}});
			}
		},
		mounted(){
		    var mySwiper = new Swiper('.swiper-container', {
				slidesPerView: 3,
				spaceBetween: 10,
				slidesPerGroup: 3,
				loop: false,
				loopFillGroupWithBlank: true,
				observer:true,//修改swiper自己或子元素时，自动初始化swiper 
				observeParents:false,//修改swiper的父元素时，自动初始化swiper 
				onSlideChangeEnd: function(swiper){ 
					swiper.update(); 
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
		    });
 		},

		created(){
			this.getNewsNav();
			this.getBanner();
			this.getList();
			this.getItemList();
			// let sel2 =sessionStorage.getItem("sel2");
		 //  if(sel2){
		 //  	this.sel2=sel2;
		 //  }
		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.index{
	.center{
		.margin-top(20);
	}
	.newcenter{
		.margin-top(50);
		width: 100%;
		h2{
			font-weight: 700;
			.font-size(32);
			text-align: center;
		}
		P{
			text-align: center;
			.margin-bottom(30);
		}
		.company{
			.margin-bottom(30);
			ul{
				li{
					cursor:pointer;
					display: inline-block;
					.margin-left(10);
					.width(200);
					.height(60);	
					background: #eee;	
					text-align: center;
					.line-height(60);
					font-size:14px;
						
				}
				li:last-child{
					float:right;
					background:none;
				}
				.active{
						color: #fff;
						background: #00A0FF;
					}
			}
		}
		.solution{
			.height(450);
			width: 100%;
 		  	background: #eee url();
			.margin-bottom(50);
			.main{
				width:100%;
				.padding-left(10);
				.padding-right(10);
				position:absolute;
				.bottom(20);
			}
		}
		
		.cooperation{
			padding:0 10px;
			position:relative;
			.NewHand{
				.swiper-wrapper{
					.margin-left(55);
					img{
						.width(250);
						.height(300);
						border: 1px solid red;
						.margin-right(23);
					}
				}
			}
			.swiper-button-prev{
				.left(-50);
			}
			.swiper-button-next{
				.right(-50);
			}
		}
		
	}
	.movelist{
		position: relative;
		margin:0 auto;
		.move{
			margin:0 auto;
			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;
				li{
					display: inline-block;
					width: 19%;
					margin-left:calc(5%/5);
					.height(50);
					.font-size(18);
					text-align: center;
					.line-height(50);
					color: #fff;
					border: 1px solid #fff;
					.margin-bottom(10);
				}
				li:hover{
					background:#0099FF;	
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Index/Index.vue